module.exports = __webpack_public_path__ + "img/dinheiro-modal.ec5627b1.svg";